<template>
  <section class="behno-muse-image-grid-section">
    <div class="behno-muse-image-grid">
      <component
        :is="item.imageLink ? 'a' : 'div'"
        v-for="(item, index) in shopifyData.image_data"
        :key="index"
        :href="item.imageLink || null"
        class="behno-muse-image-grid-item"
        :class="{ url_link_image: item.imageLink }"
      >
        <img
          v-lazy="item.previewImg.src"
          :alt="item.previewImg.alt"
          class="behno-muse-image-grid-item-image"
          loading="lazy"
          width="100%"
          height="100%"
        />
      </component>
    </div>
  </section>
</template>
<script>
export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.behno-muse-image-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0;
}

.behno-muse-image-grid-item {
  display: block;
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.5s infinite;
  transform: translateZ(0);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.behno-muse-image-grid-item-image {
  display: block;
  width: 100%;
  height: auto;
  transform: translateZ(0);
  image-rendering: -webkit-optimize-contrast;
}

@keyframes skeleton-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.url_link_image {
  cursor: pointer;
}

@media only screen and (max-width: 1200px) {
  .behno-muse-image-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media only screen and (max-width: 768px) {
  .behno-muse-image-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
